var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.054 84.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeMiterlimit: 0.7,
    paintOrder: "markers fill stroke"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "bevel",
    strokeWidth: 5,
    d: "M71.794 83.262 37.027 9.577 2.261 83.262"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "m5.715 53.814 62.624 6.601"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "square",
    strokeWidth: 3,
    transform: "translate(-68.44 -74.7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 91.847,
    cy: 82.252,
    r: 6.053
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.147,
    cy: 87.544,
    r: 6.053
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.864b896a66c31fb99188ea4ae3dd8330.svg";
export { ForwardRef as ReactComponent };